import Components from "../components";

class NotificationBar extends Components.Base {
  bind() {
    this.on("click", "a[data-hash]", this.onClick);
  }

  onClick(e) {
    e.preventDefault();
    const $a = $(this);
    $.cookie(`hide-${$a.attr("data-hash")}`, "true", {
      path: "/",
      expires: 365,
    });
    $a.closest(".c-notification-bar").slideUp();
  }
}

Components.collection.register({
  selector: ".c-notification-bar",
  klass: NotificationBar,
});
